// src/components/routes/ProtectedRoute.js
// GR33D-SIMPLIFIED-V2: [2025-02-26] - Route protégée avec support admin

import React from 'react';
import { useWeb3 } from '../../context/Web3Context';

export const ProtectedRoute = ({ 
    element: Element, 
    requiresAuth, 
    isVestingRoute, 
    isAdminRoute,     // Paramètre pour les routes admin
    authWallets, 
    adminWallet,      // Adresse du wallet admin
    ...props 
}) => {
    const { 
        account, 
        isConnecting,
        connectWallet,
        formatAddress
    } = useWeb3();

    // Loading state
    if (isConnecting) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Connecting to Web3...</p>
            </div>
        );
    }

    // Authentication check
    if (requiresAuth && !account) {
        return (
            <div className="connect-wallet-prompt">
                <div className="prompt-content">
                    <h2>Connect Your Wallet</h2>
                    <p>Please connect your wallet to access this page</p>
                    <button 
                        className="connect-button"
                        onClick={connectWallet}
                    >
                        Connect Wallet
                    </button>
                </div>
            </div>
        );
    }

    // Admin check
    if (isAdminRoute && adminWallet && account) {
        const isAdmin = account.toLowerCase() === adminWallet.toLowerCase();
        
        if (!isAdmin) {
            return (
                <div className="error-container">
                    <div className="error-content">
                        <h2>Unauthorized Access</h2>
                        <p>This page is only accessible to the admin wallet.</p>
                        <p>Connected account: {formatAddress(account)}</p>
                    </div>
                </div>
            );
        }
    }

    // Vesting auth check
    if (isVestingRoute && authWallets && account) {
        const walletAddresses = Object.values(authWallets).map(addr => addr.toLowerCase());
        const isAuthorized = walletAddresses.includes(account.toLowerCase());
        
        if (!isAuthorized) {
            return (
                <div className="error-container">
                    <div className="error-content">
                        <h2>Unauthorized Access</h2>
                        <p>Your wallet is not authorized to access vesting functions</p>
                        <p>Only authorized wallets can view this page</p>
                    </div>
                </div>
            );
        }
    }

    // Render the protected component
    return <Element {...props} />;
};

export default ProtectedRoute;
